import { render } from "./SearchProduct.vue?vue&type=template&id=6a2d8871"
import script from "./SearchProduct.vue?vue&type=script&lang=js"
export * from "./SearchProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/quick-add-product/partials/SearchProduct.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a2d8871"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a2d8871', __exports__)) {
    api.reload('6a2d8871', __exports__)
  }
  
  module.hot.accept("./SearchProduct.vue?vue&type=template&id=6a2d8871", () => {
    api.rerender('6a2d8871', render)
  })

}


export default __exports__